import { lastNChars } from '@/helpers'
import type { IContainer, IDamageInstance } from '@/types/rc/shipments'

/**
 * Truncates a serial number like "...{numChars}"
 *
 * @param {string} sn serial number.
 * @param {string} numChars number of chars to retain on end of SN (default = 6).
 * @returns truncated serial number prefixed by an ellipsis.
 */
export const truncateSN = (sn: string | undefined, numChars: number = 6) => {
  return sn ? lastNChars(sn, numChars) : sn
}

/**
 * Split damages into new and deleted from a list of damages and an IContainer.
 *
 * @param {IDamageInstance[]} damages list of damages.
 * @param {IContainer} container server-provided container.
 * @returns {[IDamageInstance[], IDamageInstance[]]} tuple of new and deleted damages in the list with respect to the container ones.
 */
export const splitDamages = (damages: IDamageInstance[], container: IContainer) => {
  const listedDamages = new Set(damages)
  const originalDamages = new Set(container.damages)
  return [
    // Damages present in the list but not in the original server-provided container details
    // @ts-expect-error - difference is not typed
    Array.from(listedDamages.difference(originalDamages)),
    // Damages present in the original server-provided container details but not in the current list
    // @ts-expect-error - difference is not typed
    Array.from(originalDamages.difference(listedDamages)),
  ]
}
